import { render, staticRenderFns } from "./ApproveStreamSaleModal.vue?vue&type=template&id=5845aaa7&"
import script from "./ApproveStreamSaleModal.vue?vue&type=script&lang=js&"
export * from "./ApproveStreamSaleModal.vue?vue&type=script&lang=js&"
import style0 from "./ApproveStreamSaleModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports